import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Modal, Affix, Breadcrumb, Tabs } from 'antd';
import { observer } from 'mobx-react-lite';

import Pricing from 'components/QuickTurn/BoltPricing';
import PortalLoading from 'components/PortalLoading';
import Menu from 'components/QuickTurn/BoltDesignerMenu';
import { Link } from 'react-router-dom';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';
import ThreeJSCanvasBolt from 'components/QuickTurn/ThreeJSCanvasBolt';
import BoltSpecificationForm from 'components/QuickTurn/BoltSpecificationForm';

const BoltDesigner = observer(() => {
    async function fetchPart() {
        if (QuickTurnBoltStore.boltToken) {
            await QuickTurnBoltStore.getBoltByID(QuickTurnBoltStore.boltToken);
        } else {
            await QuickTurnBoltStore.startNewBolt();
        }
    }

    useEffect(() => {
        fetchPart();
    }, []);

    return (
        <>
            <Menu title="Bolt Designer" />

            <div className="container">
                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to="/quick-turn/design">QuickTurn</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Bolt Designer</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                {!QuickTurnBoltStore.boltToken || !QuickTurnBoltStore.bufferGeometry ? (
                    <PortalLoading />
                ) : (
                    <>
                        <Row gutter={[16, 0]}>
                            <Col lg={16} span={24} className="mb-3">
                                <Affix>
                                    <ThreeJSCanvasBolt
                                        showDimensions={true}
                                        showGrid={false}
                                        showGroundShadow={true}
                                        showViewCube={false}
                                    />
                                </Affix>
                            </Col>
                            <Col lg={8} span={24}>
                                <Row className="mt-0">
                                    <Col span={24} md={{ order: 3 }} sm={{ order: 2 }}>
                                        <Card bodyStyle={{ padding: '0.5rem' }}>
                                            <BoltSpecificationForm showInterestIndicators={true} />
                                        </Card>
                                    </Col>

                                    <Col span={24} md={{ order: 1 }} sm={{ order: 3 }}>
                                        <Card>
                                            <Pricing />
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
        </>
    );
});

export default BoltDesigner;
